import { useState, useEffect } from 'react';
import useApi from '../../Api';

const useItineraryInteraction = (itinerary_id, itinerary) => {
  const apiClient = useApi();
  const [userInteraction, setUserInteraction] = useState(itinerary ? itinerary.user_interaction : null);
  const [likeCount, setLikeCount] = useState(itinerary ? itinerary.like_count : 0);
  const [dislikeCount, setDislikeCount] = useState(itinerary ? itinerary.dislike_count : 0);
  const [interactionLoading, setInteractionLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (itinerary) {
      setUserInteraction(itinerary.user_interaction);
      setLikeCount(itinerary.like_count);
      setDislikeCount(itinerary.dislike_count);
    }
  }, [itinerary]);

  const likeItinerary = async () => {
    setInteractionLoading(true);
    try {
      const response = await apiClient.post(`/itineraries/${itinerary_id}/like`);
      setUserInteraction(response.data.user_interaction);
      setLikeCount(response.data.like_count);
      setDislikeCount(response.data.dislike_count);
    } catch (err) {
      setError(err.response?.data?.detail || 'Failed to like itinerary.');
    } finally {
      setInteractionLoading(false);
    }
  };

  const dislikeItinerary = async () => {
    setInteractionLoading(true);
    try {
      const response = await apiClient.post(`/itineraries/${itinerary_id}/dislike`);
      setUserInteraction(response.data.user_interaction);
      setLikeCount(response.data.like_count);
      setDislikeCount(response.data.dislike_count);
    } catch (err) {
      setError(err.response?.data?.detail || 'Failed to dislike itinerary.');
    } finally {
      setInteractionLoading(false);
    }
  };

  return { userInteraction, likeCount, dislikeCount, interactionLoading, error, likeItinerary, dislikeItinerary };
};

export default useItineraryInteraction;
